!function(root, app) {
    app.events = app.events || {};
    app.events.archives = app.events.archives || {};
    app.events.archives = {
        init: function() {
            this.defineProps();
            this.setupOverviewParallax();
        },
        defineProps: function() {
            //page containers and elements
            this.$eventLogoContainer = $('[data-js="event-logo"]');
            this.$eventOverviewForegroundImage = $('[data-js="event-overview-foreground-image"]');
            this.$eventOverviewPlayIcon = $('[data-js="overview-play-button"]');
        },
        setupOverviewParallax: function() {
            this.$eventLogoContainer.verticalParallax(.85);
            this.$eventOverviewForegroundImage.verticalParallax(.9);
            this.$eventOverviewPlayIcon.verticalParallax(.5);
        }
    };
}(this, this.app);
